import Config from "@app/config";

import type { CreditPackage } from "../types";

const PACKAGES: number[] = Config.billing.credits.packages;

export const CREDIT_PACKAGES: CreditPackage[] = PACKAGES.map((quantity) => ({
  quantity,
  price: quantity * Config.billing.credits.price,
}));
